var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart"},[(_vm.error)?[_vm._v(_vm._s(_vm.error))]:_c('Scatter',{attrs:{"chart-data":_vm.chartData,"chart-options":_vm.chartOptions,"height":_vm.height}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }